import { AsyncAutocompleteFilter, AsyncAutocompleteFilterParams } from '@cmg/data-grid';

import { useGetInvestorFilterOptionsLazyQuery } from '../../../../graphql/__generated__/GetInvestorFilterOptions';
import type { ParticipationReportGridColDef, ParticipationReportRecord } from '../../types';

export type Value = ParticipationReportRecord['investorCmgEntityName'];

type LoadInvestorFilterOptionsFn = ReturnType<typeof useGetInvestorFilterOptionsLazyQuery>[0];

const PAGE_SIZE = 25;

export const createInvestorColDef = (
  loadInvestorFilterOptions: LoadInvestorFilterOptionsFn
): ParticipationReportGridColDef<Value> => ({
  field: 'investorCmgEntityName',
  headerName: 'Investor',
  width: 179,
  floatingFilter: true,
  filter: AsyncAutocompleteFilter,
  filterParams: {
    onFetchOptions: async (searchText, page = 1) => {
      const results = await loadInvestorFilterOptions({
        variables: {
          where: { investorName: { contains: searchText } },
          take: PAGE_SIZE,
          skip: (page - 1) * PAGE_SIZE,
        },
      });
      return {
        data: results.data?.participatingInvestors?.items?.map(item => item.investorName) ?? [],
        pagination: {
          hasNext: results.data?.participatingInvestors?.pageInfo?.hasNextPage ?? false,
        },
      };
    },
  } satisfies AsyncAutocompleteFilterParams,
});
